import React from 'react';
import { IonImg } from '@ionic/react';

type LeaderboardSectionTitleProps = {
  title: string;
  iconSrc?: string;
  leadingIcon?: React.ReactNode;
  titleClassName?: string;
};

const LeaderboardSectionTitle: React.FC<LeaderboardSectionTitleProps> = ({
  title,
  iconSrc = 'assets/icon/tab-events.svg',
  leadingIcon,
  titleClassName,
}) => {
  return (
    <div className="leaderboard-section__title-wrap">
      <div className="leaderboard-section__title-badge">
        {leadingIcon ?? <IonImg src={iconSrc} className="leaderboard-section__title-icon" />}
        <span className={titleClassName}>{title}</span>
      </div>
    </div>
  );
};

export default LeaderboardSectionTitle;
